import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '2.5rem' }}>
    <h2 style={{
      fontFamily: "'Sora', sans-serif",
      fontSize: 'clamp(1.1rem,2vw,1.35rem)',
      fontWeight: 700,
      color: '#ffffff',
      marginBottom: '1rem',
      paddingBottom: '0.75rem',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
    }}>
      {title}
    </h2>
    <div style={{
      fontFamily: "'Inter', sans-serif",
      color: 'rgba(156,163,175,0.7)',
      fontSize: '0.9rem',
      lineHeight: 1.8,
    }}>
      {children}
    </div>
  </div>
);

const TermsAndConditions = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#030712', color: '#fff' }}>
      <Navbar />
      <main style={{ padding: 'clamp(1.25rem,5vw,5rem)', paddingTop: '100px', paddingBottom: '5rem' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div style={{
              display: 'inline-block',
              padding: '0.25rem 0.875rem',
              borderRadius: '100px',
              background: 'rgba(123,97,255,0.1)',
              border: '1px solid rgba(123,97,255,0.2)',
              fontFamily: "'Sora', sans-serif",
              fontSize: '0.65rem',
              fontWeight: 700,
              color: '#7B61FF',
              textTransform: 'uppercase',
              letterSpacing: '0.25em',
              marginBottom: '1.5rem',
            }}>
              Legal
            </div>

            <h1 style={{
              fontFamily: "'Sora', sans-serif",
              fontSize: 'clamp(2rem,5vw,3.5rem)',
              fontWeight: 800,
              letterSpacing: '-0.5px',
              lineHeight: 1.1,
              marginBottom: '0.75rem',
            }}>
              Terms & Conditions
            </h1>

            <p style={{
              fontFamily: "'Inter', sans-serif",
              color: 'rgba(156,163,175,0.5)',
              fontSize: '0.85rem',
              marginBottom: '3rem',
            }}>
              Last updated: May 21, 2026 — Zynqora Edge, Islamabad, Pakistan
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <Section title="1. Acceptance of Terms">
              <p>By accessing or using <strong style={{ color: 'rgba(255,255,255,0.8)' }}>www.zynqoraedge.com</strong> or engaging Zynqora Edge for services, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our website or services.</p>
            </Section>

            <Section title="2. Services">
              <p style={{ marginBottom: '0.75rem' }}>Zynqora Edge provides custom AI systems, workflow automation, SaaS development, mobile applications, and web development services. All services are provided under separate project agreements or statements of work.</p>
              <p>We reserve the right to modify, suspend, or discontinue any service at any time with reasonable notice.</p>
            </Section>

            <Section title="3. Intellectual Property">
              <ul style={{ paddingLeft: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <li><strong style={{ color: 'rgba(255,255,255,0.75)' }}>Client deliverables:</strong> Upon full payment, clients receive ownership of the custom-built deliverables specified in the project agreement.</li>
                <li><strong style={{ color: 'rgba(255,255,255,0.75)' }}>Pre-existing IP:</strong> Zynqora Edge retains ownership of all proprietary frameworks, tools, libraries, and methodologies developed prior to or independently of a client engagement.</li>
                <li><strong style={{ color: 'rgba(255,255,255,0.75)' }}>Website content:</strong> All content on www.zynqoraedge.com including text, design, logos, and media is the property of Zynqora Edge and may not be reproduced without written permission.</li>
              </ul>
            </Section>

            <Section title="4. Service Usage">
              <p style={{ marginBottom: '0.75rem' }}>You agree not to:</p>
              <ul style={{ paddingLeft: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <li>Use our website or services for any unlawful purpose</li>
                <li>Attempt to gain unauthorized access to our systems or data</li>
                <li>Reproduce or distribute our proprietary content without consent</li>
                <li>Interfere with the proper functioning of our website or services</li>
                <li>Misrepresent your identity or affiliation when contacting us</li>
              </ul>
            </Section>

            <Section title="5. Payment Terms">
              <p>Payment terms are outlined in individual project agreements. Generally, projects require a deposit before work commences. Zynqora Edge reserves the right to pause or terminate work if payments are not received per the agreed schedule.</p>
            </Section>

            <Section title="6. Limitations of Liability">
              <p>Zynqora Edge shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from use of our services or website. Our total liability for any claim arising from a project shall not exceed the total fees paid for that specific project.</p>
            </Section>

            <Section title="7. Warranties & Disclaimers">
              <p>We warrant that our services will be performed with reasonable skill and care. The website and its content are provided "as is" without warranties of any kind. We do not guarantee that AI systems will perform with 100% accuracy in all scenarios, and outputs should be reviewed by qualified personnel for critical decisions.</p>
            </Section>

            <Section title="8. Confidentiality">
              <p>Both parties agree to maintain the confidentiality of sensitive business information shared during a project engagement. This obligation survives termination of the project relationship.</p>
            </Section>

            <Section title="9. Governing Law">
              <p>These Terms are governed by the laws of the Islamic Republic of Pakistan. Any disputes shall be resolved through good-faith negotiation, and failing that, through appropriate legal channels in Islamabad, Pakistan.</p>
            </Section>

            <Section title="10. Changes to Terms">
              <p>We may update these Terms periodically. Continued use of our website or services after changes constitutes acceptance of the updated Terms. We will update the "Last updated" date at the top of this page.</p>
            </Section>

            <Section title="11. Contact">
              <p>
                For questions regarding these Terms:<br/>
                <strong style={{ color: 'rgba(255,255,255,0.75)' }}>Zynqora Edge</strong><br/>
                Islamabad HQ &amp; Global Operations<br/>
                Email: <strong style={{ color: '#7B61FF' }}>haris@harisbuilds.com</strong><br/>
                Phone: +1 239 517 7689
              </p>
            </Section>

            <div style={{
              marginTop: '3rem',
              paddingTop: '2rem',
              borderTop: '1px solid rgba(255,255,255,0.06)',
              display: 'flex',
              gap: '1rem',
              flexWrap: 'wrap',
            }}>
              <Link to="/" style={{ color: '#7B61FF', fontFamily: "'Sora', sans-serif", fontSize: '0.85rem', fontWeight: 600, textDecoration: 'none' }}>← Back to Home</Link>
              <Link to="/privacy-policy" style={{ color: 'rgba(156,163,175,0.5)', fontFamily: "'Sora', sans-serif", fontSize: '0.85rem', textDecoration: 'none' }}>Privacy Policy →</Link>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
};

export default TermsAndConditions;